import type { Dict } from '../index.js';

/** Arabic: leave. Keys are the exact English text. */
export const leave: Dict = {
  // My leave
  'My leave': 'إجازاتي',
  'Your balances and requests. Weekends and public holidays are never counted.': 'أرصدتك وطلباتك. لا تُحتسب عطلات نهاية الأسبوع والعطلات الرسمية أبدًا.',
  'Request leave': 'طلب إجازة',
  "Your request was submitted. You'll get a notification when it is reviewed.": 'تم إرسال طلبك. سيصلك إشعار عند مراجعته.',
  'Upcoming ({n})': 'القادمة ({n})',
  'Pending ({n})': 'قيد الانتظار ({n})',
  'Previous ({n})': 'السابقة ({n})',
  'No upcoming leave': 'لا توجد إجازات قادمة',
  'No pending requests': 'لا توجد طلبات قيد الانتظار',
  'No previous requests': 'لا توجد طلبات سابقة',

  // My balance / ledger
  'No movements yet': 'لا توجد حركات بعد',
  'Date': 'التاريخ',
  'Movement': 'الحركة',
  'Days': 'الأيام',
  'Details': 'التفاصيل',
  'by {name}': 'بواسطة {name}',
  'My balance': 'رصيدي',
  'Every change to your balance is listed — nothing is changed without a record.': 'كل تغيير على رصيدك مُدرج هنا — لا يتغير شيء دون تسجيل.',
  'Year': 'السنة',
  '{type} — history': '{type} — السجل',
  'History': 'السجل',
  'Select a leave type above. History starts with your first request or adjustment in this leave year.': 'اختر نوع إجازة من الأعلى. يبدأ السجل بأول طلب أو تعديل لك في سنة الإجازات هذه.',
  'Yearly entitlement': 'الاستحقاق السنوي',
  'Allowance changed': 'تغيير الاستحقاق',
  'Carried over': 'مُرحَّل',
  'Manual adjustment': 'تعديل يدوي',
  'Leave taken': 'إجازة مأخوذة',
  'Leave returned': 'إجازة مُستردة',

  // Balances (admin)
  'Vacation balances': 'أرصدة الإجازات',
  'Entitlement, usage and remaining days per employee. Click a row for the full history and adjustments.': 'الاستحقاق والمستخدم والأيام المتبقية لكل موظف. انقر على صف لعرض السجل الكامل والتعديلات.',
  'Search employee': 'بحث عن موظف',
  'Leave type': 'نوع الإجازة',
  'Department': 'القسم',
  'All departments': 'جميع الأقسام',
  'Leave year': 'سنة الإجازات',
  'Leave year {year}': 'سنة الإجازات {year}',
  'No employees': 'لا يوجد موظفون',
  'Employee': 'الموظف',
  'Entitled': 'المستحق',
  'Carried': 'المُرحَّل',
  'Adjusted': 'المُعدَّل',
  'Used': 'المستخدم',
  'Pending': 'قيد الانتظار',
  'Remaining': 'المتبقي',
  'Not applicable': 'لا ينطبق',
  '{name} — leave balances': '{name} — أرصدة الإجازات',
  '{type} history': 'سجل {type}',
  'Adjust balance': 'تعديل الرصيد',
  'Change allowance': 'تغيير الاستحقاق',
  'No movements yet in this leave year': 'لا توجد حركات بعد في سنة الإجازات هذه',
  'Days to add (use a minus sign to deduct)': 'الأيام المراد إضافتها (استخدم علامة السالب للخصم)',
  'Whole or half days, e.g. 2, -1, 0.5. Use this for opening balances or compensation days.': 'أيام كاملة أو أنصاف أيام، مثل 2 أو -1 أو 0.5. استخدم هذا للأرصدة الافتتاحية أو أيام التعويض.',
  'e.g. 2 or -1': 'مثل 2 أو -1',
  'Yearly allowance for this employee (currently {n})': 'الاستحقاق السنوي لهذا الموظف (حاليًا {n})',
  'Overrides the policy allowance for this leave year only.': 'يحل محل استحقاق السياسة لسنة الإجازات هذه فقط.',
  'Reason': 'السبب',
  'Recorded in the balance history and audit log, and shown to the employee.': 'يُسجَّل في سجل الرصيد وسجل التدقيق، ويظهر للموظف.',
  'Apply adjustment': 'تطبيق التعديل',
  'Save allowance': 'حفظ الاستحقاق',

  // Leave admin
  'Leave approvals': 'الموافقة على الإجازات',
  'Leave': 'الإجازات',
  'Requests from your team': 'طلبات فريقك',
  'All leave requests across the company': 'جميع طلبات الإجازة في الشركة',
  'Leave types & policies': 'أنواع الإجازات والسياسات',
  'Record leave': 'تسجيل إجازة',
  'Requests': 'الطلبات',
  'Calendar': 'التقويم',
  'Status': 'الحالة',
  'Pending approval': 'بانتظار الموافقة',
  'Approved': 'موافق عليها',
  'Rejected': 'مرفوضة',
  'Cancelled': 'ملغاة',
  'All statuses': 'جميع الحالات',
  'All leave types': 'جميع أنواع الإجازات',
  'All employees': 'جميع الموظفين',
  'Nothing waiting for approval 🎉': 'لا يوجد ما ينتظر الموافقة 🎉',
  'No requests match': 'لا توجد طلبات مطابقة',
  'Previous month': 'الشهر السابق',
  'Today': 'اليوم',
  'Next month': 'الشهر التالي',
  'Mon': 'الإثنين',
  'Tue': 'الثلاثاء',
  'Wed': 'الأربعاء',
  'Thu': 'الخميس',
  'Fri': 'الجمعة',
  'Sat': 'السبت',
  'Sun': 'الأحد',
  '(pending)': '(قيد الانتظار)',
  '(half day)': '(نصف يوم)',
  '+{n} more': '+{n} أخرى',
  'Solid = approved · dashed = waiting for approval · ½ = half day': 'مصمت = موافق عليها · متقطع = بانتظار الموافقة · ½ = نصف يوم',
  'Record leave for an employee': 'تسجيل إجازة لموظف',
  'Select employee…': 'اختر الموظف…',

  // Leave setup
  'Leave types define the rules; policies define how many days each group of employees gets per year.': 'تحدد أنواع الإجازات القواعد، وتحدد السياسات عدد الأيام التي تحصل عليها كل مجموعة من الموظفين سنويًا.',
  'Leave types': 'أنواع الإجازات',
  'Leave policies': 'سياسات الإجازات',
  'New leave type': 'نوع إجازة جديد',
  'No leave types yet': 'لا توجد أنواع إجازات بعد',
  'Main vacation type': 'نوع الإجازة الرئيسي',
  'Inactive': 'غير نشط',
  'Paid': 'مدفوعة',
  'Unpaid': 'غير مدفوعة',
  'Needs approval': 'تتطلب موافقة',
  'Auto-approved': 'موافقة تلقائية',
  'Uses balance': 'تخصم من الرصيد',
  'No balance': 'بلا رصيد',
  'Negative allowed': 'يُسمح بالرصيد السالب',
  'Full days only': 'أيام كاملة فقط',
  'Max {n}/request': 'الحد الأقصى {n}/طلب',
  'Max {n}/year': 'الحد الأقصى {n}/سنة',
  'Only {countries}': '{countries} فقط',
  'Edit': 'تعديل',
  'Delete': 'حذف',
  'Edit leave type': 'تعديل نوع الإجازة',
  'Cancel': 'إلغاء',
  'Save': 'حفظ',
  'Name': 'الاسم',
  'e.g. Annual Vacation': 'مثل: إجازة سنوية',
  'Code': 'الرمز',
  'Optional, e.g. AL': 'اختياري، مثل AL',
  'Description': 'الوصف',
  'Requires approval': 'تتطلب موافقة',
  'Off = approved automatically when submitted.': 'عند الإيقاف = تتم الموافقة تلقائيًا عند الإرسال.',
  'Deducts from balance': 'تُخصم من الرصيد',
  'Off for e.g. unpaid leave.': 'أوقفه مثلًا للإجازة غير المدفوعة.',
  'Allow negative balance': 'السماح بالرصيد السالب',
  'Employees may request more than they have.': 'يمكن للموظفين طلب أكثر من رصيدهم.',
  'Allow half days': 'السماح بأنصاف الأيام',
  "Shown as 'Vacation balance' on dashboards.": 'يظهر باسم «رصيد الإجازات» في لوحات المعلومات.',
  'Max days per request': 'الحد الأقصى للأيام لكل طلب',
  'Empty = no limit': 'فارغ = بلا حد',
  'Max days per leave year': 'الحد الأقصى للأيام في سنة الإجازات',
  'Colour': 'اللون',
  'Only for employees in these countries': 'للموظفين في هذه الدول فقط',
  'Leave empty for all countries. Hold Ctrl/Cmd to select several.': 'اتركه فارغًا لجميع الدول. اضغط باستمرار على Ctrl/Cmd لاختيار أكثر من دولة.',
  'Active': 'نشط',
  "Inactive types can't be requested; history is kept.": 'لا يمكن طلب الأنواع غير النشطة، ويُحتفظ بالسجل.',
  'Delete {name}?': 'حذف {name}؟',
  'This leave type has never been used, so it can be deleted permanently.': 'لم يُستخدم نوع الإجازة هذا مطلقًا، لذا يمكن حذفه نهائيًا.',
  'New policy': 'سياسة جديدة',
  'No leave policies yet': 'لا توجد سياسات إجازات بعد',
  'Create one per country or contract type, then assign it to employees.': 'أنشئ سياسة لكل دولة أو نوع عقد، ثم عيّنها للموظفين.',
  '{n} employee': '{n} موظف',
  '{n} employees': '{n} موظفين',
  '{n} days': '{n} يوم',
  'monthly': 'شهريًا',
  'up front': 'مقدمًا',
  'carry ≤ {n}': 'ترحيل ≤ {n}',
  'Edit leave policy': 'تعديل سياسة الإجازات',
  'New leave policy': 'سياسة إجازات جديدة',
  'Save policy': 'حفظ السياسة',
  'Changes apply to leave years created from now on. Balances that already exist keep their allowance — change individual balances on the Vacation Balances page if needed.': 'تنطبق التغييرات على سنوات الإجازات التي تُنشأ من الآن فصاعدًا. تحتفظ الأرصدة الموجودة باستحقاقها — عدّل الأرصدة الفردية من صفحة أرصدة الإجازات عند الحاجة.',
  'e.g. Egypt — standard': 'مثل: مصر — قياسية',
  'Allowances per leave year': 'الاستحقاقات لكل سنة إجازات',
  'Select…': 'اختر…',
  'Days / year': 'أيام / سنة',
  'Earned': 'الاستحقاق',
  'All at start of year': 'كاملة في بداية السنة',
  'Monthly': 'شهريًا',
  'Max carry-over': 'الحد الأقصى للترحيل',
  'Remove': 'إزالة',
  'Add leave type': 'إضافة نوع إجازة',
  'Policies that are or were assigned to employees are kept for history and can only be deactivated.': 'يُحتفظ بالسياسات المعيّنة أو التي عُيّنت سابقًا للموظفين لأغراض السجل، ويمكن إيقافها فقط.',

  // Standard leave types and policies (from the company setup template)
  'Annual Vacation': 'إجازة سنوية',
  'Sick Leave': 'إجازة مرضية',
  'Emergency Leave': 'إجازة طارئة',
  'Unpaid Leave': 'إجازة غير مدفوعة',
  'Maternity Leave': 'إجازة أمومة',
  'Paternity Leave': 'إجازة أبوة',
  'Egypt — standard': 'مصر — قياسية',
  'Saudi Arabia — standard': 'السعودية — قياسية',
  'Lebanon — standard': 'لبنان — قياسية',

  // Leave request form
  '{days} left': 'متبقٍّ {days}',
  'no balance used': 'لا تخصم من الرصيد',
  'First day': 'اليوم الأول',
  'Last day': 'اليوم الأخير',
  'Full day': 'يوم كامل',
  'Morning only': 'الفترة الصباحية فقط',
  'Afternoon only': 'الفترة المسائية فقط',
  'First day: afternoon only': 'اليوم الأول: الفترة المسائية فقط',
  'Last day: morning only': 'اليوم الأخير: الفترة الصباحية فقط',
  'Reason / comment': 'السبب / ملاحظة',
  'Optional. Visible to your manager and administrators.': 'اختياري. يظهر لمديرك ولمسؤولي النظام.',
  'Approve immediately': 'الموافقة فورًا',
  'Records the leave as approved (e.g. sick leave reported by phone). Leave off to send it for approval.': 'تُسجَّل الإجازة كموافق عليها (مثل إجازة مرضية أُبلغ عنها هاتفيًا). اتركه متوقفًا لإرسالها للموافقة.',
  'Summary': 'الملخص',
  'Days requested': 'الأيام المطلوبة',
  'Leave year {start} – {end} ({days})': 'سنة الإجازات {start} – {end} ({days})',
  'Available now': 'المتاح حاليًا',
  'Balance after this request': 'الرصيد بعد هذا الطلب',
  'Not counted': 'غير محتسبة',
  'day off': 'يوم عطلة',
  '{name} (half day)': '{name} (نصف يوم)',
  'not employed': 'خارج فترة التوظيف',
  'Will be recorded as approved.': 'ستُسجَّل كموافق عليها.',
  'Will be sent to your manager / an administrator for approval.': 'ستُرسل إلى مديرك / مسؤول النظام للموافقة.',
  'This leave type is approved automatically.': 'تتم الموافقة على هذا النوع من الإجازات تلقائيًا.',
  'Submit request': 'إرسال الطلب',

  // Server-side preview messages shown with t() (static ones only)
  'This employee is deactivated.': 'هذا الموظف غير مفعَّل.',
  'A request cannot be longer than one year.': 'لا يمكن أن تتجاوز مدة الطلب سنة واحدة.',
  'Some dates are outside the employment period.': 'بعض التواريخ خارج فترة التوظيف.',
  'There are no working days in the selected dates (weekends and public holidays are not counted).': 'لا توجد أيام عمل في التواريخ المحددة (لا تُحتسب عطلات نهاية الأسبوع والعطلات الرسمية).',
  'This request spans two leave years; days are counted against each year separately.': 'يمتد هذا الطلب على سنتي إجازات؛ تُحتسب الأيام من رصيد كل سنة على حدة.',

  // Leave request list
  'No leave requests': 'لا توجد طلبات إجازة',
  'Requested {date} by {name}': 'طُلبت في {date} بواسطة {name}',
  'Requested {date}': 'طُلبت في {date}',
  'Approved by {name}': 'وافق عليها {name}',
  'Rejected by {name}': 'رفضها {name}',
  'system': 'النظام',
  'Cancelled by {name}': 'ألغاها {name}',
  'Approve': 'موافقة',
  'Reject': 'رفض',
  'Approve leave?': 'الموافقة على الإجازة؟',
  'Reject leave?': 'رفض الإجازة؟',
  'Cancel leave?': 'إلغاء الإجازة؟',
  'The days are deducted from the balance and the employee is notified.': 'تُخصم الأيام من الرصيد ويُبلَّغ الموظف.',
  'The days are returned to the balance.': 'تُعاد الأيام إلى الرصيد.',
  'Cancel leave': 'إلغاء الإجازة',
  'Reason for rejection': 'سبب الرفض',
  'Comment (optional)': 'ملاحظة (اختياري)',
  'Reason (optional)': 'السبب (اختياري)',
  'Shown to the employee.': 'يظهر للموظف.',

  // Balance cards
  'No leave allowances assigned yet. An administrator sets them through the leave policy.': 'لم تُحدَّد استحقاقات إجازة بعد. يحددها مسؤول النظام من خلال سياسة الإجازات.',
  'days left': 'يوم متبقٍّ',
  'Carried over from last year and manual adjustments': 'المُرحَّل من السنة الماضية والتعديلات اليدوية',
  'Extra': 'إضافي',
  'Earned so far: {accrued} of {entitled} (monthly accrual)': 'المكتسب حتى الآن: {accrued} من {entitled} (استحقاق شهري)',

  // lib/leave.ts
  '{n} day': '{n} يوم',
  'afternoon': 'الفترة المسائية',
  'morning': 'الفترة الصباحية',
  'pm': 'مساءً',
  'am': 'صباحًا',
  '{start} → {end}': '{start} ← {end}',
};
